export function validateBundleInfo({ mismatch }, { exposedDependencies = {}, logService, packageName, }) {
    if (!mismatch || !logService) {
        return;
    }
    const data = { package: packageName, dependencies: JSON.stringify(mismatch) };
    if (Object.keys(exposedDependencies).length === 0) {
        logService.warning({
            category: 'MicroFrontends.NoExposedDependencies',
            message: 'Cannot use light bundle because the host is not exposing dependencies or the list of shared dependencies is empty.',
            data,
        });
    }
    else {
        logService.warning({
            category: 'MicroFrontends.DependenciesMismatch',
            message: 'Some of the package dependencies have incompatible versions.',
            data,
        });
    }
}
//# sourceMappingURL=validate-bundle-info.js.map